// extracted by mini-css-extract-plugin
module.exports = {"license":"License-module--license--54mFD","image":"License-module--image--16Yph","text":"License-module--text--LXyCG"};